






















import { computed, defineComponent } from '@vue/composition-api'
import {
  onMounted,
  PropType,
  ref,
  toRefs,
  useContext,
  watch,
} from '@nuxtjs/composition-api'
import InputSelect from '../Inputs/InputSelect.vue'
import { CityOption } from '@/components/FormInput/BlockNearestOffice.typing'
import { CityModel } from '@/contracts/api/QueryCities.Response'
import { RegionModel } from '@/contracts/api/QueryRegion.Response'

export default defineComponent({
  components: {
    InputSelect,
  },
  props: {
    value: {
      type: Object as PropType<CityModel>,
      default: null,
    },
    region: {
      type: Object as PropType<RegionModel>,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    showLable: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    styleType: {
      type: String,
      default: 'old',
    },
  },
  setup(props, { emit }) {
    const { disabled, region, placeholder } = toRefs(props)
    const { $api } = useContext()

    const options = ref<CityOption[]>([])
    const loading = ref<boolean>(false)
    const errorMsg = ref<false | string>(false)

    const customPlaceholder = computed<string>(() =>
      loading?.value
        ? 'Загрузка...'
        : placeholder?.value
        ? placeholder?.value
        : 'Ничего не выбрано'
    )

    const getCityName = (city: CityModel): string => {
      if (city.city_type && city.settlement) {
        return `${city.city_type}. ${city.city}, ${city.settlement_type}. ${city.settlement}`
      }

      if (city.city_type) {
        return `${city.city_type}. ${city.city}`
      }

      return `${city.settlement_type}. ${city.settlement}`
    }

    const fetchCities = async (): Promise<void> => {
      if (disabled?.value) {
        options.value = []
        return
      }

      try {
        loading.value = true
        const { data } = await $api.requests.getCities(
          region?.value
            ? { federation_code: region?.value?.value?.SUBJECT_FEDERATION_CODE }
            : ''
        )

        if (data.status === 200 && data.data.length) {
          options.value = data.data
            .filter((city) => !!city.offices_ids.length)
            .map((city) => ({
              name: getCityName(city),
              value: city,
            }))
        } else {
          errorMsg.value = 'Ошибка загрузки'
        }
      } catch (e) {
        errorMsg.value = 'Ошибка загрузки'
      } finally {
        loading.value = false
      }
    }

    const onChange = (event: CityOption) => {
      emit('input', event)
    }

    onMounted(fetchCities)
    watch(region, fetchCities)

    const isCompareCity = (option: CityOption, data: CityModel | null) => {
      return !!option && !!data && option.value.kladr_id === data.value.kladr_id
    }

    return {
      customPlaceholder,
      options,
      errorMsg,
      loading,
      onChange,
      isCompareCity,
    }
  },
})
